export default /* glsl */`
uniform sampler2D uMap;
uniform vec3 uColor;

varying float vOpacity;

void main() {
  gl_FragColor = vec4(uColor, texture2D(uMap, vec2(gl_PointCoord.x, 1.0 - gl_PointCoord.y))[0] * vOpacity );
}
`